import { NgModule } from '@angular/core';
import { UptimePipe } from './uptime.pipe';


@NgModule({
    imports: [],
    exports: [UptimePipe],
    declarations: [UptimePipe],
    providers: [],
})
export class UptimePipeModule { }
